<div class="ebo-input" [class.ebo-input--error]="hasError" [class.ebo-input--focused]="isFocused">
  <!-- Label -->
  <span *ngIf="label" class="ebo-input__label">
    {{ label }}
    <span *ngIf="required" class="ebo-input__required">*</span>
  </span>

  <!-- Plain text mode -->
  <input
    *ngIf="!hasChips"
    [type]="type"
    [placeholder]="placeholder"
    [value]="control?.value ?? ''"
    (input)="onInputChange($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    class="ebo-input__control"
    [attr.aria-label]="label"
    [attr.aria-required]="required"
  />

  <!-- Chips mode -->
  <div *ngIf="hasChips" class="ebo-input__control ebo-input__control--chips" (click)="chipInput.focus()">
    <span *ngFor="let chip of chips; let i = index" class="ebo-chip">
      <span class="ebo-chip__label">{{ chip }}</span>
      <button type="button" class="ebo-chip__remove" (click)="$event.stopPropagation(); removeChip(i)" [attr.aria-label]="'Remove ' + chip">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M0.792893 0.43934C1.37868 -0.146447 2.32843 -0.146447 2.91421 0.43934L14.935 12.4602C15.5208 13.0459 15.5208 13.9957 14.935 14.5815C14.3492 15.1673 13.3995 15.1673 12.8137 14.5815L0.792893 2.56066C0.207107 1.97487 0.207107 1.02513 0.792893 0.43934Z"
            fill="#8760C0"
          />
          <path
            d="M0.43934 14.935C-0.146447 14.3492 -0.146447 13.3995 0.43934 12.8137L12.4602 0.792892C13.0459 0.207106 13.9957 0.207106 14.5815 0.792893C15.1673 1.37868 15.1673 2.32843 14.5815 2.91421L2.56066 14.935C1.97487 15.5208 1.02513 15.5208 0.43934 14.935Z"
            fill="#8760C0"
          />
        </svg>
      </button>
    </span>

    <input
      #chipInput
      type="text"
      class="ebo-input__field"
      [placeholder]="chips.length ? '' : placeholder"
      [value]="inputValue"
      (input)="onChipInput($event)"
      (keydown)="onChipKeyDown($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [attr.aria-label]="label"
      [attr.aria-required]="required"
    />
  </div>

  <!-- Hint Text -->
  <span *ngIf="hint && !hasError" class="ebo-input__hint">
    {{ hint }}
  </span>

  <!-- Error Text -->
  <span *ngIf="hasError" class="ebo-input__error">
    {{ errorMessage }}
  </span>
</div>
